import * as Api from "@api";
import { State } from "../";
import { ActionType } from "../types";
import { ThunkAction } from "redux-thunk";
import { Application, ApplicationsAction } from "../types/applications";

function getApplicationsRequest(): ApplicationsAction {
  return {
    type: ActionType.GET_APPLICATIONS_REQUEST,
  };
}

function getApplicationsSuccess(
  applications: Application[]
): ApplicationsAction {
  return {
    type: ActionType.GET_APPLICATIONS_SUCCESS,
    applications,
  };
}

function getApplicationsFailure(error: any): ApplicationsAction {
  return {
    type: ActionType.GET_APPLICATIONS_FAILURE,
    error,
  };
}

export function getApplications(): ThunkAction<
  void,
  State,
  unknown,
  ApplicationsAction
> {
  return async (dispatch, getState) => {
    const { network } = getState();

    if (!network.fetching.applications) {
      dispatch(getApplicationsRequest());
      try {
        const applications = await Api.getApplications();

        dispatch(getApplicationsSuccess(applications));
      } catch (error) {
        dispatch(getApplicationsFailure(error));
      }
    }
  };
}
